export default {
      id: "yandexmetrika-usage",
      viewBox: "0 0 19 18",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#yandexmetrika-usage",
      toString: function () {
        return this.url;
      }
    }